import emailjs from '@emailjs/browser';

const TO_EMAIL = 'vanzari@youngerkarom.ro';

export class EmailNotConfiguredError extends Error {
  constructor(message) {
    super(message);
    this.name = 'EmailNotConfiguredError';
  }
}

function getEmailJsConfig() {
  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  if (!serviceId || !templateId || !publicKey) return null;
  return { serviceId, templateId, publicKey };
}

/**
 * Sends the quote request email.
 *
 * EmailJS setup (recommended):
 * - Add these env vars in a `.env` file (CRA requires REACT_APP_ prefix):
 *   - REACT_APP_EMAILJS_SERVICE_ID=...
 *   - REACT_APP_EMAILJS_TEMPLATE_ID=...
 *   - REACT_APP_EMAILJS_PUBLIC_KEY=...
 * - In your EmailJS template, include variables:
 *   - to_email, from_name, contact_name, company_name, reply_to, message, lang
 */
export async function sendQuoteRequest({ name, company, phone, email, message, lang }) {
  const cfg = getEmailJsConfig();

  if (!cfg) {
    throw new EmailNotConfiguredError(
      'EmailJS is not configured. Set REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID, and REACT_APP_EMAILJS_PUBLIC_KEY.'
    );
  }

  const enrichedMessage = [
    `Email: ${email || ''}`,
    `Company: ${company || ''}`,
    `Phone: ${phone || ''}`,
    '',
    message || '',
  ].join('\n');

  const params = {
    to_email: TO_EMAIL,
    to: TO_EMAIL,
    toEmail: TO_EMAIL,
    recipient: TO_EMAIL,
    recipient_email: TO_EMAIL,
    from_name: company || name || '',
    contact_name: name || '',
    company_name: company || '',
    name: name || '',
    reply_to: email || '',
    from_email: email || '',
    company: company || '',
    phone: phone || '',
    message: enrichedMessage,
    lang: lang || 'ro',
  };

  await emailjs.send(cfg.serviceId, cfg.templateId, params, {
    publicKey: cfg.publicKey,
  });

  return { mode: 'emailjs' };
}
